module.exports = __webpack_public_path__ + "img/initial-reader.8441995f.png";